import { ChevronDown } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PanduanDaftarQrisku() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [activeIndex, setActiveIndex] = useState(null);

  const data = [
    {
      title: "Berapa lama proses pengajuan QRIS ?",
      content:
        "Proses pembuatan 2 – 6 hari kerja atau menyesuaikan antrian pembuatan QRIS",
    },
    {
      title: "Apakah ada biaya pembuatan QRIS ?",
      content:
        "Ya, biaya admin QRIS mengikuti peraturan dari Bank Nobu, yang akan kami informasikan setiap terdapat perubahan aturan",
    },
    {
      title: "Apakah seluruh mitra Kenzie Komunika bisa membuat QRIS?",
      content:
        "Ya, seluruh mitra Kenzie Komunika dapat mengajukan pembuatan QRIS",
    },
    {
      title: "Dimanakah saldo pencairan dana QRIS saya masuk ?",
      content:
        "Dana QRIS mitra Kenzie Komunika menambah saldo agen di aplikasi Kenzie Komunika",
    },
    {
      title: "Berapa lama pencairan dana ke saldo agen di aplikasi Kenzie Komunika ?",
      content:
        "Pencairan dana otomatis masuk ke saldo di aplikasi Kenzie Komunika saat pelanggan bertransaksi menggunakan QRIS.",
    },
    {
      title: "Apakah Kenzie Komunika akan mendapatkan keuntungan dari mitra yang membuat QRIS ?",
      content:
        "Perusahaan tidak mendapatkan keuntungan materil apapun dari proses pembuatan QRIS. Perusahaan sebagai penyedia layanan aplikasi Kenzie Komunika hanya membantu memberikan fasilitas kepada mitra Kenzie Komunika untuk memberi kemudahan dalam berniaga dan bertransaksi menggunakan Kenzie Komunika. Dari fasilitas tersebut mitra Kenzie Komunika dapat meningkatkan penjualan, dan mempermudah transaksi jual beli tanpa uang tunai (cashless)",
    },
  ];

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white ">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 pt-40 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274]  bg-clip-text text-transparent">
            Panduan Aplikasi Android Kenzie Komunika APK
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-6"></div>
          {/* <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Showcasing our best work and successful project deliveries across various industries
          </p> */}
        </div>
      </section>

      {/* Filter Section */}
      {/* <section 
        data-section="filter"
        className="py-8 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('filter') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-red-600 text-white shadow-lg shadow-blue-500/50'
                    : 'bg-slate-800 text-gray-400 hover:text-white hover:bg-slate-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section> */}

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-5 bg-white"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('projects') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-row gap-8 items-center justify-center">
            <div className='w-2/4 flex'>
              <img
                src="/images/panduan/qrisku.png"
                alt="Animation"
                className="w-full max-w-xl object-contain flex items-center justify-center transition-all duration-300 transform hover:scale-125"
              />
            </div>
            <div className='w-2/4 p-4'>
              <h1 className='text-2xl pb-4 text-slate-700'>Daftarkan outlet / toko kamu dengan pembayaran via QRIS di Kenzie Komunika APK, untuk pengalaman berbelanja yang lebih menyenangkan dan memuaskan.</h1>
              <p>
                <ol class="list-decimal list-outside text-slate-700 ml-8 font-medium text-md">
                  <li><span className='font-bold text-[#3E3274]'>Gratis</span> : Pembuatan QRIS akan di bantu oleh Kenzie Komunika APK dan GRATIS.</li>
                  <li><span className='font-bold text-[#3E3274]'>Meningkatkan Penjualan</span>: Sebagai merchant QRIS, Anda dapat menerima pembayaran dari berbagai aplikasi pembayaran.</li>
                  <li><span className='font-bold text-[#3E3274]'>Lebih Praktis</span>: Satu kode QR diterima oleh semua aplikasi pembayaran sehingga pelanggan akan senang karena merasa dimudahkan</li>
                  <li><span className='font-bold text-[#3E3274]'>Lebih Efisien</span>: Mengurangi biaya pengelolaan kas dan memudahkan pencatatan keuangan. Dengan QRIS tidak perlu lagi repot mencari uang kecil untuk kembalian dan tidak lagi harus setor tunai hasil penjualanmu ke ATM/bank.</li>
                  <li><span className='font-bold text-[#3E3274]'>Keamanan Transaksi</span>: QRIS memberikan tingkat keamanan yang lebih tinggi dalam transaksi non-tunai. Kamu tidak perlu khawatir tentang menerima uang palsu atau kehilangan uang tunai.</li>
                  <li><span className='font-bold text-[#3E3274]'>Meningkatkan Branding</span>: Dengan menerima pembayaran melalui QRIS, usaha Anda menjadi lebih up-to-date dan bisa meningkatkan branding usaha Anda.</li>
                </ol>
              </p>
            </div>
          </div>
        </div>
        <div className={`relative py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-3xl md:text-3xl text-center  font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Persyaratan Daftar QRISku
          </h1>
          <div className="flex flex-row gap-8 items-center justify-center">
            <div className='w-2/4 flex items-center justify-center'>
              <ol class="list-decimal list-outside text-slate-700 ml-8 font-medium text-md">
                <li>Foto atau scan KTP pemilik outlet/toko</li>
                <li>
                  Melampirkan data pribadi sebagai berikut :
                  <ul className='list-disc list-outside text-slate-700 ml-4 font-medium text-md '>
                    <li>Agen id yang terdaftar di Kenzie Komunika</li>
                    <li>NIK pemilik outlet/toko</li>
                    <li>Nama outlet/toko</li>
                    <li>Alamat outlet/toko</li>
                    <li>Nama sesuai KTP</li>
                    <li>Kota Domisili</li>
                    <li>Kode Pos</li>
                    <li>Nomor Handphone</li>
                    <li>Email</li>
                  </ul>
                </li>
                <li>Terdaftar di Kenzie Komunika</li>
              </ol>
            </div>
            <div className='w-2/4 flex '>
              <img
                src="/images/panduan/register.png"
                alt="Animation"
                className="w-full p-8 max-w-xl object-contain flex items-center justify-center transition-all duration-300 transform hover:scale-125"
              />
            </div>
          </div>
        </div>
        <div className={`relative py-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-3xl md:text-3xl text-center  font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Proses Pendaftaran QRISku
          </h1>
          <div className="absolute inset-0">
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
          </div>
          <div className="flex flex-row gap-8 items-center justify-center group">
            <div className='w-2/4 flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300'>
              <img
                src="/images/panduan/register2.png"
                alt="Animation"
                className="w-full p-8 max-w-xl object-contain flex items-center justify-center "
              />
            </div>
            <div className='w-2/4 flex items-center justify-center'>
              <p className='p-4'>
                <h1 className='text-2xl font-bold mb-4'> Proses pendaftaran sebagai berikut :</h1>
                <ol class="list-decimal list-outside text-gray-400 ml-8 font-medium text-md mb-4">
                  <li>Siapkan semua persyaratan yang di perlukan</li>
                  <li>Kemudian isikan form dan data yang di perlukan di (link ini).</li>
                  <li>Proses verifikasi berkas</li>
                  <li>Setelah semua persyaratan sudah terverifikasi oleh tim Kenzie Komunika Mobile, pengajuan QRIS telah selesai dan mitra akan dihubungi oleh pihak Kenzie Komunika Mobile untuk diinfokan QRIS yang sudah di buat</li>
                </ol>
                <h1 className='text-2xl font-bold mb-4'> Catatan:</h1>
                <ul className='ml-8 list-disc list-outside text-gray-400 ml-4 font-medium text-md '>
                  <li>Pihak Kenzie Komunika tidak pernah meminta OTP dalam proses pembuatan QRIS</li>
                  <li>Pembuatan QRIS secara GRATIS tanpa ada pungutan apapun.</li>
                  <li>Seluruh kebijakan pembuatan,perubahan dan ketentuan berasal dari QRIS Bank Nobu yang diawasi oleh kebijakan Bank Indonesia</li>
                  <li>Pihak Kenzie Komunika hanya memfasilitasi pembuatan QRIS mitra Kenzie Komunika</li>
                </ul>
              </p>
              
            </div>
            
          </div>
        </div>

        <div className={`relative py-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-3xl md:text-3xl text-center  font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Frequently Asked Questions
          </h1>
          <div className="flex flex-row gap-8 items-center justify-center">
            <div className="max-w-2xl mx-auto space-y-4">
              {data.map((item, index) => (
                <div
                  key={index}
                  className="border border-slate-700 rounded-2xl overflow-hidden bg-gradient-to-r from-red-500 to-[#3E3274]"
                >
                  {/* Header */}
                  <button
                    onClick={() => toggle(index)}
                    className="w-full flex justify-between items-center px-6 py-4 text-left"
                  >
                    <span className="text-lg font-semibold text-white">
                      {item.title}
                    </span>
                    <ChevronDown
                      className={`transition-transform duration-300 ${
                        activeIndex === index ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {/* Content */}
                  <div
                    className={`grid transition-all duration-500 ease-in-out ${
                      activeIndex === index
                        ? "grid-rows-[1fr] opacity-100"
                        : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="px-6 pb-4 text-white">
                        {item.content}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-gradient-to-b from-slate-100/95 to-slate-100/90 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Ayo bergabung menjadi mitra Kami!
          </h2>
          <p className="text-xl text-slate-700 mb-8">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>
          <Link 
            to="/contact"
            className="inline-block px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
          >
            Mulai mendaftar
          </Link>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
